import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import { getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
let router = useRouter();
//录音（结束后计算分数返回$emit('setScores')）-播放按钮-
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach(item => {
  if (!cookies[item.split("=")[0].trim()]) cookies[item.split("=")[0].trim()] = item.split("=")[1];
});
export default {
  props: ["record_switch", "record_time", "replay_switch", "coreType", "refText", "stop_switch", "qType"],
  setup(props, content) {
    let overlay = ref(false);
    let recorderLoadState = ref(false);
    let recordId = ref("");
    let store = useStore();
    const {
      proxy
    } = getCurrentInstance();
    onMounted(() => {
      if (!proxy.$recorder) {
        /* eslint-disable */
        proxy.$recorder = new _17kouyu.IRecorder({
          id: "recorder",
          //这里为HTML节点对应的id
          appKey: store.state.recorderKey.appKey,
          secretKey: store.state.recorderKey.secretKey,
          // encode: "raw",
          mode: 2 /*1:flash模式, 2:html5模式, 3:html5优先,当浏览器不支持html5时自动切换为flash模式*/,
          onFlashLoad: (code, message) => {
            //Flash加载完成的回调，其他所有与录音机的操作必须在这个回调之后进行。
            //code值有：50000
            recorderLoadState.value = true;
          },
          onConnectorStatusChange: (code, message) => {
            //连接器状态发生改变时回调
            //code值有：50100, 50103, 50104, 50109
            if (!code == 50100) {
              ElMessageBox.confirm(`链接服务器失败，请稍后重试`, "", {
                showClose: false,
                showCancelButton: false,
                cancelButtonText: false,
                type: "warning"
              }).then(() => {
                content.emit("recorderDefeat");
              });
            }
          },
          onMicStatusChange: (code, message) => {
            //麦克风状态发生改变时回调。第一次加载Flash时也会触发该回调
            //code值有：50001, 50002, 50003
            if (code == 50002) {
              ElMessageBox.confirm(`获取权限失败，不能访问麦克风，请开启当前浏览器麦克风的访问权限并刷新页面`, "", {
                showClose: false,
                showCancelButton: false,
                cancelButtonText: false,
                type: "warning",
                confirmButtonText: "终止测试"
              }).then(() => {
                content.emit("recorderDefeat");
              }).catch(() => {
                content.emit("recorderDefeat");
              });
            } else if (code == 50003) {
              ElMessageBox.confirm(`获取权限失败，不能访问麦克风,请开启当前浏览器麦克风的访问权限并刷新页面`, "", {
                showClose: false,
                showCancelButton: false,
                cancelButtonText: false,
                type: "warning",
                confirmButtonText: "终止测试"
              }).then(() => {
                content.emit("recorderDefeat");
              }).catch(() => {
                content.emit("recorderDefeat");
              });
            }
          },
          onError: (code, msg) => {
            ElMessageBox.confirm(`考试中断,请重新进入考试`, "", {
              showClose: false,
              showCancelButton: false,
              cancelButtonText: false,
              confirmButtonText: "终止考试",
              type: "warning"
            }).then(() => {
              content.emit("recorderDefeat");
            }).catch(() => {
              content.emit("recorderDefeat");
            });
          }
        });
      }
    });
    //开始录音
    function startRecord() {
      let serverParams = {};
      props.coreType ? serverParams.coreType = props.coreType : "";
      serverParams.refText = props.refText;
      if (props.coreType == store.state.eval.CORE_TYPE_OPEN) {
        serverParams.qType = props.qType;
      }
      proxy.$recorder.record({
        duration: props.record_time || 3000,
        //录音时长，单位ms
        serverParams: {
          attachAudioUrl: 1,
          scale: 12,
          //录音评分参数，具体取决于服务类型
          userId: cookies["user-id"] ? cookies["user-id"] : "trial",
          ...serverParams
          // playNotifyAudio: false, ding声
        },
        onRecordIdGenerated: (code, message) => {
          recordId.value = message.recordId;
          //服务器返回唯一的ID: message.recordId
        },
        onStart: () => {
          //录音开始的回调
          content.emit("recording", true);
        },
        onStop: () => {
          //到达指定时间，录音自动停止的回调
        },
        onComplete: function (message) {
          //评分回调，message为json string
        }
      });
    }
    //停止录音
    function stopRecord() {
      proxy.$recorder.stop({
        onStop: () => {
          document.getElementById("ding_audio").play();
          //录音手动停止的回调
          getScores();
        }
      });
    }
    //开始回放
    function startReplay() {
      proxy.$recorder.startReplay({
        recordId: recordId.value,
        onStart: function () {
          //回放开始的回调
        },
        onStop: () => {
          //回放自动停止的回调
          content.emit("stopReplay");
        }
      });
      try {
        startReplay;
      } catch (e) {}
    }

    // 获取分数
    function getScores() {
      proxy.$recorder.getScores({
        recordId: recordId.value,
        //指定的录音ID
        success: r => {
          let data = r[recordId.value];
          if (!data || data.err || data.error) {
            ElMessageBox.confirm(`考试中断，请重新尝试或者更换设备`, "", {
              showClose: false,
              showCancelButton: false,
              cancelButtonText: false,
              type: "warning"
            }).then(() => {
              router.replace("/examlist");
            });
          } else {
            if (data.result.warning) {
              let message = "";
              switch (data.result.warning[0].code) {
                case 1001:
                  message = "系统检测到录音存在问题，可能影响您的评分。";
                  break;
                case 1002:
                  message = "系统检测到您的声音太小或距离麦克风太远。";
                  break;
                case 1003:
                  message = "系统检测到您的声音太高,可能影响评分。";
                  break;
                case 1004:
                  message = "系统检测到您的周围有噪音,可能影响评分。";
                  break;
                case 1005:
                  message = "系统检测到您的音频不完整,可能影响评分。";
                  break;
              }
              if (message) ElMessage({
                type: "error",
                showClose: true,
                message: message
              });
            } else if (data.result.overall == 0) {
              ElMessage({
                type: "error",
                showClose: true,
                message: "系统检测当前您的录音存在异常，建议您关闭页面重新进入考试并录音"
              });
            }
            content.emit("setScores", data);
          }
          //评分获得后回调。这里可能是评分成功，或者评分出错
          //详细评分结果在 data[lastRecordId].result
          //如果没有 result字段，则表明评分超时；如果 result字段中含有
          //err 或者 error字段，则评分出错。具体出错原因为result.errID
        }
      });
      try {
        startReplay;
      } catch (e) {}
    }
    //监听参数
    watch(() => props.record_switch, () => {
      overlay.value = true;
      ElMessageBox.confirm(`倒计时结束，开始录音`, "", {
        showClose: false,
        showCancelButton: false,
        cancelButtonText: false,
        type: "info"
      }).then(() => {
        startRecord();
        overlay.value = false;
      }).catch(() => {
        startRecord();
        overlay.value = false;
      });
    });
    watch(() => props.replay_switch, () => {
      startReplay();
    });
    watch(() => props.stop_switch, () => {
      stopRecord();
    });
    onBeforeUnmount(() => {
      proxy.$recorder.stop();
      proxy.$recorder.clear();
    });
    return {
      overlay
    };
  }
};